import React, { Component } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './SheetPage.css';

// One page of the multi-page sheet composer -- a single Quill instance
// inside an A4-styled box, with a custom toolbar that mixes Quill's own
// formatting buttons alongside a plain "Remove Sheet" button. Pages are
// added/removed manually by the user (see SheetComposer); this component
// just owns the editor itself and exposes its content to the parent at
// submit time.
//
// Quill needs the toolbar container DOM node to already be mounted before
// it instantiates -- render the toolbar first, wait for its ref via a
// callback ref (which triggers a re-render), and only mount <ReactQuill>
// once that's ready.
class SheetPage extends Component {
	constructor(props) {
		super(props);
		this.quillRef = React.createRef();
		this.toolbarNode = null;
		this.state = { toolbarReady: false };
	}

	setToolbarRef = (node) => {
		if (node && !this.toolbarNode) {
			this.toolbarNode = node;
			this.setState({ toolbarReady: true });
		}
	};

	getQuill = () => (this.quillRef.current ? this.quillRef.current.getEditor() : null);

	getHTML = () => {
		const quill = this.getQuill();
		return quill ? quill.root.innerHTML : '';
	};

	isEmpty = () => {
		const quill = this.getQuill();
		if (!quill) return true;
		return quill.getText().trim().length === 0;
	};

	render() {
		const { initialDelta, pageLabel, showRemove, onRemove } = this.props;
		return (
			<div className="sheet-page">
				<div className="ql-toolbar ql-snow sheet-toolbar" ref={this.setToolbarRef}>
					<span className="ql-formats">
						<select className="ql-header" defaultValue="">
							<option value="1" />
							<option value="2" />
							<option value="3" />
							<option value="" />
						</select>
					</span>
					<span className="ql-formats">
						<button className="ql-bold" type="button" />
						<button className="ql-italic" type="button" />
						<button className="ql-underline" type="button" />
						<button className="ql-strike" type="button" />
					</span>
					<span className="ql-formats">
						<button className="ql-list" value="ordered" type="button" />
						<button className="ql-list" value="bullet" type="button" />
					</span>
					<span className="ql-formats">
						<button className="ql-link" type="button" />
						<button className="ql-image" type="button" />
					</span>
					<span className="ql-formats">
						<button className="ql-clean" type="button" />
					</span>
					<span className="ql-formats sheet-toolbar-meta">
						{pageLabel && <span className="sheet-page-label">{pageLabel}</span>}
						{showRemove && (
							<button type="button" className="sheet-remove-btn" onClick={onRemove}>
								Remove Sheet
							</button>
						)}
					</span>
				</div>
				{this.state.toolbarReady && (
					<ReactQuill
						ref={this.quillRef}
						theme="snow"
						defaultValue={initialDelta || undefined}
						modules={{ toolbar: { container: this.toolbarNode } }}
					/>
				)}
			</div>
		);
	}
}

export default SheetPage;
